import { defineMessages } from "react-intl";

const parkingTypes = defineMessages({
  freeOnPremise: {
    id: "shared.parking_types.free_on_premise",
    defaultMessage: "Free onsite parking",
  },
  paidOnPremise: {
    id: "shared.parking_types.paid_on_premise",
    defaultMessage: "Paid onsite parking",
  },
  freeStreet: {
    id: "shared.parking_types.free_street",
    defaultMessage: "Free street parking",
  },
  meteredStreet: {
    id: "shared.parking_types.metered_street",
    defaultMessage: "Metered street parking",
  },
  valet: { id: "shared.parking_types.valet", defaultMessage: "Valet" },
  nearbyLot: {
    id: "shared.parking_types.nearby_lot",
    defaultMessage: "Nearby parking lot",
  },
});

const parkingTypesList = [
  { key: "01_free_on_premise", label: parkingTypes.freeOnPremise, index: 0 },
  { key: "02_paid_on_premise", label: parkingTypes.paidOnPremise, index: 1 },
  { key: "03_free_street", label: parkingTypes.freeStreet, index: 2 },
  { key: "04_metered_street", label: parkingTypes.meteredStreet, index: 3 },
  { key: "05_valet", label: parkingTypes.valet, index: 4 },
  { key: "06_nearby_lot", label: parkingTypes.nearbyLot, index: 5 },
];

export default parkingTypesList;
